import { render, staticRenderFns } from "./LinkCampus.vue?vue&type=template&id=ac1a3242&scoped=true&"
import script from "./LinkCampus.vue?vue&type=script&lang=js&"
export * from "./LinkCampus.vue?vue&type=script&lang=js&"
import style0 from "./LinkCampus.vue?vue&type=style&index=0&id=ac1a3242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1a3242",
  null
  
)

export default component.exports